// Photo Booth style effects - these manipulate the canvas pixels
function effect4Up(ctx, w, h) {
  ctx.drawImage(ctx.canvas, 0, 0, w, h, 0, 0, w / 2, h / 2)
  ctx.drawImage(ctx.canvas, 0, 0, w / 2, h / 2, w / 2, 0, w / 2, h / 2)
  ctx.drawImage(ctx.canvas, 0, 0, w / 2, h / 2, 0, h / 2, w / 2, h / 2)
  ctx.drawImage(ctx.canvas, 0, 0, w / 2, h / 2, w / 2, h / 2, w / 2, h / 2)
}

function effectMirrorH(ctx, w, h) {
  ctx.save()
  ctx.translate(w, 0)
  ctx.scale(-1, 1)
  ctx.drawImage(ctx.canvas, 0, 0, w / 2, h, 0, 0, w / 2, h)
  ctx.restore()
}

function effectMirrorV(ctx, w, h) {
  ctx.save()
  ctx.translate(0, h)
  ctx.scale(1, -1)
  ctx.drawImage(ctx.canvas, 0, 0, w, h / 2, 0, 0, w, h / 2)
  ctx.restore()
}

function effectKaleidoscope(ctx, w, h) {
  // Mirror right half
  ctx.save()
  ctx.translate(w, 0)
  ctx.scale(-1, 1)
  ctx.drawImage(ctx.canvas, 0, 0, w / 2, h, 0, 0, w / 2, h)
  ctx.restore()
  // Mirror bottom half
  ctx.save()
  ctx.translate(0, h)
  ctx.scale(1, -1)
  ctx.drawImage(ctx.canvas, 0, 0, w, h / 2, 0, 0, w, h / 2)
  ctx.restore()
}

function effectStretch(ctx, w, h) {
  const strip = w / 20
  for (let i = 0; i < 20; i++) {
    const srcX = w * 0.3 + (w * 0.4) * (i / 20)
    ctx.drawImage(ctx.canvas, srcX, 0, 1, h, i * strip, 0, strip, h)
  }
}

function effectSqueeze(ctx, w, h) {
  const imgData = ctx.getImageData(0, 0, w, h)
  const src = imgData.data
  const output = ctx.createImageData(w, h)
  const dst = output.data
  const cx = w / 2
  const cy = h / 2
  const radius = Math.min(w, h) * 0.5
  const strength = 0.5

  for (let y = 0; y < h; y++) {
    for (let x = 0; x < w; x++) {
      const dx = x - cx
      const dy = y - cy
      const dist = Math.sqrt(dx * dx + dy * dy)
      let srcX, srcY
      if (dist < radius) {
        const r = dist / radius
        const newR = Math.pow(r, 1 / (1 + strength)) * radius
        const angle = Math.atan2(dy, dx)
        srcX = cx + Math.cos(angle) * newR
        srcY = cy + Math.sin(angle) * newR
      } else {
        srcX = x
        srcY = y
      }
      const sx = Math.floor(srcX)
      const sy = Math.floor(srcY)
      if (sx >= 0 && sx < w && sy >= 0 && sy < h) {
        const si = (sy * w + sx) * 4
        const di = (y * w + x) * 4
        dst[di] = src[si]
        dst[di + 1] = src[si + 1]
        dst[di + 2] = src[si + 2]
        dst[di + 3] = src[si + 3]
      }
    }
  }
  ctx.putImageData(output, 0, 0)
}

function effectBulge(ctx, w, h) {
  const imgData = ctx.getImageData(0, 0, w, h)
  const src = imgData.data
  const output = ctx.createImageData(w, h)
  const dst = output.data
  const cx = w / 2
  const cy = h / 2
  const radius = Math.min(w, h) * 0.45
  const strength = 1.8

  for (let y = 0; y < h; y++) {
    for (let x = 0; x < w; x++) {
      const dx = x - cx
      const dy = y - cy
      const dist = Math.sqrt(dx * dx + dy * dy)
      let srcX, srcY
      if (dist < radius) {
        const r = dist / radius
        const newR = Math.pow(r, strength) * radius
        const angle = Math.atan2(dy, dx)
        srcX = cx + Math.cos(angle) * newR
        srcY = cy + Math.sin(angle) * newR
      } else {
        srcX = x
        srcY = y
      }
      const sx = Math.floor(srcX)
      const sy = Math.floor(srcY)
      if (sx >= 0 && sx < w && sy >= 0 && sy < h) {
        const si = (sy * w + sx) * 4
        const di = (y * w + x) * 4
        dst[di] = src[si]
        dst[di + 1] = src[si + 1]
        dst[di + 2] = src[si + 2]
        dst[di + 3] = src[si + 3]
      }
    }
  }
  ctx.putImageData(output, 0, 0)
}

function effectTwirl(ctx, w, h) {
  const imgData = ctx.getImageData(0, 0, w, h)
  const src = imgData.data
  const output = ctx.createImageData(w, h)
  const dst = output.data
  const cx = w / 2
  const cy = h / 2
  const radius = Math.min(w, h) * 0.45
  const angle = Math.PI * 1.5

  for (let y = 0; y < h; y++) {
    for (let x = 0; x < w; x++) {
      const dx = x - cx
      const dy = y - cy
      const dist = Math.sqrt(dx * dx + dy * dy)
      let srcX, srcY
      if (dist < radius) {
        const percent = 1 - dist / radius
        const theta = percent * percent * angle
        const cos = Math.cos(theta)
        const sin = Math.sin(theta)
        srcX = cx + dx * cos - dy * sin
        srcY = cy + dx * sin + dy * cos
      } else {
        srcX = x
        srcY = y
      }
      const sx = Math.floor(srcX)
      const sy = Math.floor(srcY)
      if (sx >= 0 && sx < w && sy >= 0 && sy < h) {
        const si = (sy * w + sx) * 4
        const di = (y * w + x) * 4
        dst[di] = src[si]
        dst[di + 1] = src[si + 1]
        dst[di + 2] = src[si + 2]
        dst[di + 3] = src[si + 3]
      }
    }
  }
  ctx.putImageData(output, 0, 0)
}

function effect9Up(ctx, w, h) {
  const third = 1 / 3
  ctx.drawImage(ctx.canvas, 0, 0, w, h, 0, 0, w * third, h * third)
  ctx.drawImage(ctx.canvas, 0, 0, w * third, h * third, w * third, 0, w * third, h * third)
  ctx.drawImage(ctx.canvas, 0, 0, w * third, h * third, w * 2 * third, 0, w * third, h * third)
  ctx.drawImage(ctx.canvas, 0, 0, w * third, h * third, 0, h * third, w * third, h * third)
  ctx.drawImage(ctx.canvas, 0, 0, w * third, h * third, w * third, h * third, w * third, h * third)
  ctx.drawImage(ctx.canvas, 0, 0, w * third, h * third, w * 2 * third, h * third, w * third, h * third)
  ctx.drawImage(ctx.canvas, 0, 0, w * third, h * third, 0, h * 2 * third, w * third, h * third)
  ctx.drawImage(ctx.canvas, 0, 0, w * third, h * third, w * third, h * 2 * third, w * third, h * third)
  ctx.drawImage(ctx.canvas, 0, 0, w * third, h * third, w * 2 * third, h * 2 * third, w * third, h * third)
}

export const filterConfigs = [
  { name: 'Normal', filter: 'none' },
  { name: 'Warm', filter: 'sepia(0.2) saturate(1.3) brightness(1.05)' },
  { name: 'Cool', filter: 'saturate(0.8) brightness(1.05) hue-rotate(10deg)' },
  { name: 'Vintage', filter: 'sepia(0.4) contrast(1.1) brightness(0.95) saturate(0.8)' },
  { name: 'B&W', filter: 'grayscale(1) contrast(1.1)' },
  { name: 'High Contrast', filter: 'contrast(1.4) brightness(1.05)' },
  { name: 'Soft', filter: 'brightness(1.1) contrast(0.9) saturate(0.9)' },
  { name: 'Vivid', filter: 'saturate(1.6) contrast(1.1)' },
  { name: 'Dramatic', filter: 'contrast(1.3) brightness(0.9) saturate(1.2)' },
  { name: 'Fade', filter: 'brightness(1.1) saturate(0.6) contrast(0.85)' },
  { name: 'Sepia', filter: 'sepia(0.7) brightness(1.05)' },
  { name: 'Noir', filter: 'grayscale(1) contrast(1.4) brightness(0.85)' },
  { name: 'Golden', filter: 'sepia(0.3) saturate(1.5) brightness(1.1) hue-rotate(-10deg)' },
  { name: 'Arctic', filter: 'brightness(1.1) saturate(0.7) hue-rotate(180deg)' },
  { name: 'Sunset', filter: 'sepia(0.25) saturate(1.4) hue-rotate(-20deg) brightness(1.05)' },
  { name: 'Lo-Fi', filter: 'contrast(1.5) saturate(1.3) brightness(0.95)' },
  { name: 'Muted', filter: 'saturate(0.4) brightness(1.05) contrast(0.95)' },
  { name: 'Haze', filter: 'brightness(1.2) contrast(0.8) saturate(0.7)' },
  { name: 'Punch', filter: 'contrast(1.3) saturate(1.5) brightness(1.05)' },
  { name: 'Pastel', filter: 'brightness(1.15) saturate(0.5) contrast(0.85)' },
  { name: 'Emerald', filter: 'hue-rotate(90deg) saturate(0.8) brightness(1.05)' },
  { name: 'Rosé', filter: 'hue-rotate(-30deg) saturate(1.2) brightness(1.05) sepia(0.1)' },
  { name: 'Midnight', filter: 'brightness(0.7) contrast(1.3) saturate(0.6) hue-rotate(200deg)' },
  { name: 'Overexposed', filter: 'brightness(1.4) contrast(0.85)' },
  { name: 'Underexposed', filter: 'brightness(0.7) contrast(1.2)' },
  { name: 'Retro', filter: 'sepia(0.5) hue-rotate(-15deg) saturate(1.2) contrast(0.9)' },
  { name: 'Film', filter: 'sepia(0.15) contrast(1.15) brightness(0.95) saturate(0.85)' },
  { name: 'Dreamy', filter: 'brightness(1.15) contrast(0.85) saturate(1.2) blur(0.5px)' },
  { name: 'Invert', filter: 'invert(1)' },
  { name: 'Neon', filter: 'saturate(2.5) contrast(1.2) brightness(1.1)' },
  // Photo Booth effects
  { name: '4-Up', filter: 'none', effect: effect4Up },
  { name: '9-Up', filter: 'none', effect: effect9Up },
  { name: 'Mirror', filter: 'none', effect: effectMirrorH },
  { name: 'Flip', filter: 'none', effect: effectMirrorV },
  { name: 'Kaleidoscope', filter: 'none', effect: effectKaleidoscope },
  { name: 'Stretch', filter: 'none', effect: effectStretch },
  { name: 'Squeeze', filter: 'none', effect: effectSqueeze },
  { name: 'Bulge', filter: 'none', effect: effectBulge },
  { name: 'Twirl', filter: 'none', effect: effectTwirl },
  // Combo: Photo Booth effect + color filter
  { name: '4-Up B&W', filter: 'grayscale(1) contrast(1.1)', effect: effect4Up },
  { name: '4-Up Vintage', filter: 'sepia(0.4) contrast(1.1) brightness(0.95) saturate(0.8)', effect: effect4Up },
  { name: 'Mirror Noir', filter: 'grayscale(1) contrast(1.4) brightness(0.85)', effect: effectMirrorH },
]
